import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

function CandidateQuizDashboard({ candidateId }) {
  const [assignments, setAssignments] = useState([]);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [quizData, setQuizData] = useState(null);
  const [answers, setAnswers] = useState({});
  const [step, setStep] = useState('list'); // list | take | result
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAssignments();
  }, []);

  const fetchAssignments = async () => {
    setLoading(true);
    const res = await fetch(`${API_URL}/api/quiz/candidate/${candidateId}/assigned`);
    const data = await res.json();
    if (data.success) setAssignments(data.assignments);
    setLoading(false);
  };

  const handleStartQuiz = async assignment => {
    setLoading(true);
    setSelectedAssignment(assignment);
    setStep('take');
    const res = await fetch(`${API_URL}/api/quiz/candidate/assignment/${assignment.id}`);
    const data = await res.json();
    if (data.success) setQuizData(data.assignment.Quiz);
    setLoading(false);
  };

  const handleAnswer = (questionId, optionId) => {
    setAnswers({ ...answers, [questionId]: optionId });
  };

  const handleSubmitQuiz = async () => {
    setLoading(true);
    const answerArr = Object.entries(answers).map(([question_id, selected_option_id]) => ({ question_id, selected_option_id }));
    const res = await fetch(`${API_URL}/api/quiz/candidate/assignment/${selectedAssignment.id}/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ answers: answerArr })
    });
    const data = await res.json();
    if (data.success) {
      setResult(data.score);
      setStep('result');
      fetchAssignments();
    }
    setLoading(false);
  };

  if (step === 'take' && quizData) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #e0f7fa 0%, #f8fafc 100%)', padding: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ maxWidth: 700, margin: '0 auto', background: 'rgba(255,255,255,0.85)', borderRadius: 28, boxShadow: '0 8px 32px #22c55e22', border: '1.5px solid #e0f7fa', padding: 40, backdropFilter: 'blur(8px)' }}>
          <h2 style={{ fontWeight: 900, fontSize: 32, color: '#22c55e', marginBottom: 24, letterSpacing: 1 }}>📝 {quizData.title}</h2>
          {quizData.QuizQuestions.map((q, qidx) => (
            <div key={q.id} style={{ marginBottom: 32 }}>
              <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 18, color: '#222' }}>{qidx + 1}. {q.question_text}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {q.QuizOptions.map(opt => (
                  <label key={opt.id} style={{ display: 'flex', alignItems: 'center', gap: 12, background: answers[q.id] === opt.id || answers[q.id] === String(opt.id) ? 'linear-gradient(90deg, #bbf7d0 0%, #e0f7fa 100%)' : '#f8fafc', borderRadius: 18, padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 16, border: answers[q.id] === opt.id || answers[q.id] === String(opt.id) ? '2px solid #22c55e' : '1.5px solid #e0f7fa', transition: 'all 0.18s' }}>
                    <input
                      type="radio"
                      name={`q_${q.id}`}
                      value={opt.id}
                      checked={answers[q.id] === String(opt.id) || answers[q.id] === opt.id}
                      onChange={() => handleAnswer(q.id, opt.id)}
                      style={{ accentColor: '#22c55e', width: 18, height: 18 }}
                    />
                    {opt.option_text}
                  </label>
                ))}
              </div>
            </div>
          ))}
          <button className="gogig-card-btn" onClick={handleSubmitQuiz} disabled={loading} style={{ marginTop: 18, borderRadius: 32, padding: '14px 0', fontWeight: 800, fontSize: 20, background: 'linear-gradient(90deg, #22c55e 0%, #2ad2c9 100%)', color: '#fff', boxShadow: '0 2px 16px #22c55e44', border: 'none', width: '100%', letterSpacing: 1, transition: 'background 0.18s, transform 0.18s' }}>{loading ? 'Submitting...' : 'Submit Quiz'}</button>
        </div>
      </div>
    );
  }

  if (step === 'result') {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #e0f7fa 0%, #f8fafc 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ background: 'rgba(255,255,255,0.92)', borderRadius: 28, boxShadow: '0 8px 32px #22c55e22', border: '1.5px solid #e0f7fa', padding: 56, minWidth: 340, textAlign: 'center', backdropFilter: 'blur(8px)' }}>
          <h2 style={{ color: '#22c55e', fontWeight: 900, marginBottom: 18, fontSize: 32, letterSpacing: 1 }}>🎉 Quiz Completed!</h2>
          <div style={{ fontSize: 26, fontWeight: 800, marginBottom: 18, color: '#2ad2c9' }}>Your Score: {result}</div>
          <button className="gogig-card-btn" onClick={() => { setStep('list'); setResult(null); setAnswers({}); }} style={{ borderRadius: 32, padding: '14px 0', fontWeight: 800, fontSize: 18, background: 'linear-gradient(90deg, #22c55e 0%, #2ad2c9 100%)', color: '#fff', boxShadow: '0 2px 16px #22c55e44', border: 'none', width: '100%', letterSpacing: 1, transition: 'background 0.18s, transform 0.18s' }}>Back to Quizzes</button>
        </div>
      </div>
    );
  }

  // Quiz List
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #e0f7fa 0%, #f8fafc 100%)', padding: 32 }}>
      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <h2 style={{ fontWeight: 900, fontSize: 32, color: '#22c55e', marginBottom: 32, letterSpacing: 1 }}>📝 My Quizzes</h2>
        {loading ? <div>Loading...</div> : (
          <div style={{ background: 'rgba(255,255,255,0.85)', borderRadius: 24, boxShadow: '0 8px 32px #22c55e22', border: '1.5px solid #e0f7fa', overflow: 'hidden' }}>
            <div style={{ padding: 18, borderBottom: '1.5px solid #e0f7fa', fontWeight: 700, color: '#22c55e', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 16, background: 'linear-gradient(90deg, #e0f7fa 0%, #f8fafc 100%)', fontSize: 17, letterSpacing: 0.5 }}>
              <div>Quiz</div>
              <div>Status</div>
              <div>Action</div>
            </div>
            {assignments.map((a, idx) => (
              <div key={a.id} style={{ padding: 18, borderBottom: '1.5px solid #e0f7fa', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 16, alignItems: 'center', background: idx % 2 === 0 ? 'rgba(34,197,94,0.06)' : 'rgba(42,210,201,0.06)', transition: 'background 0.2s', cursor: 'pointer' }} onMouseOver={e => e.currentTarget.style.background='rgba(34,197,94,0.13)'} onMouseOut={e => e.currentTarget.style.background=idx%2===0?'rgba(34,197,94,0.06)':'rgba(42,210,201,0.06)'}>
                <div style={{ fontWeight: 600, color: '#222', fontSize: 16 }}>{a.Quiz?.title}</div>
                <div style={{ fontWeight: 700, color: a.completed_at ? '#22c55e' : '#f39c12', fontSize: 15 }}>{a.completed_at ? 'Completed' : 'Pending'}</div>
                <div>
                  {a.completed_at ? (
                    <button className="gogig-card-btn-outline" onClick={async () => {
                      setLoading(true);
                      const res = await fetch(`${API_URL}/api/quiz/candidate/assignment/${a.id}/result`);
                      const data = await res.json();
                      setResult(data.assignment.score);
                      setStep('result');
                      setLoading(false);
                    }} style={{ borderRadius: 32, padding: '10px 24px', fontWeight: 700, fontSize: 16, color: '#22c55e', border: '2px solid #22c55e', background: 'rgba(255,255,255,0.85)', transition: 'all 0.18s', boxShadow: '0 2px 8px #22c55e11', letterSpacing: 0.5 }}>View Result</button>
                  ) : (
                    <button className="gogig-card-btn" onClick={() => handleStartQuiz(a)} style={{ borderRadius: 32, padding: '10px 24px', fontWeight: 800, fontSize: 16, background: 'linear-gradient(90deg, #22c55e 0%, #2ad2c9 100%)', color: '#fff', boxShadow: '0 2px 16px #22c55e44', border: 'none', letterSpacing: 0.5, transition: 'background 0.18s, transform 0.18s' }}>Take Quiz</button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CandidateQuizDashboard; 